import { atomWithReset } from 'jotai/utils';
export const modalAtom = atomWithReset<{
  isOpen: boolean;
  title: string;
  description: string;
  component: ({
    onClose
  }: {
    onClose: () => void;
  }) => React.ReactNode;
}>({
  isOpen: false,
  title: '',
  description: '',
  component: () => null
});